export enum Environment {
  INTEGRATION = "integration",
  STAGING = "staging",
  PRODUCTION = "production"
}

export enum ToggleState {
  ENABLED = "enabled",
  DISABLED = "disabled",
  ERROR = "error"
}

export enum ToggleType {
  CUSTOMER_COUNTRY = "CustomerCountry",
  GLOBAL = "Global"
}
